import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';
import MobileLayout from './MobileLayout';
import { MOBILE_CREATE_SUBMISSION_ROUTE } from '../tradeups/CreateSubmissionOnBehalf';
import { canCreateSubmissionOnBehalf } from '../tradeups/createSubmissionOnBehalfShared';

const MobileHome: React.FC = () => {
  const history = useHistory();

  return (
    <MobileLayout>
      <Typography variant="h5" gutterBottom sx={{ mt: 2 }}>
        Mobile
      </Typography>
      <Box display="flex" flexDirection="column" gap={2}>
        <Card sx={{ cursor: 'pointer' }} onClick={() => history.push('/mobile/pick')}>
          <CardContent>
            <Typography variant="h6">Run Pick Wave</Typography>
            <Typography variant="body2" color="text.secondary">
              Start or resume a fulfillment pick wave
            </Typography>
          </CardContent>
        </Card>
        {canCreateSubmissionOnBehalf() && (
          <Card
            sx={{ cursor: 'pointer' }}
            onClick={() => history.push(MOBILE_CREATE_SUBMISSION_ROUTE)}
          >
            <CardContent>
              <Typography variant="h6">Create Submission</Typography>
              <Typography variant="body2" color="text.secondary">
                Enter a bike submission for a customer
              </Typography>
            </CardContent>
          </Card>
        )}
      </Box>
    </MobileLayout>
  );
};

export default MobileHome;
